import { render, staticRenderFns } from "./OfficeCoordinate.vue?vue&type=template&id=c0ecf788&scoped=true&"
import script from "./OfficeCoordinate.vue?vue&type=script&lang=js&"
export * from "./OfficeCoordinate.vue?vue&type=script&lang=js&"
import style0 from "./OfficeCoordinate.vue?vue&type=style&index=0&id=c0ecf788&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ecf788",
  null
  
)

export default component.exports